import { FC } from 'react';
import { AssetStoryblok } from 'storyblok-types';
import { Image } from 'atoms/Image/Image';
import { TABLET_WIDTH } from 'modules/mui/hooks';

interface PictureProps {
  srcMobile?: AssetStoryblok;
  srcDesktop?: AssetStoryblok;
  className?: string;
  rootClassName?: string;
}

export const Picture: FC<PictureProps> = ({
  srcMobile,
  srcDesktop,
  className,
  rootClassName,
}) => {
  return (
    <picture className={rootClassName}>
      <source
        srcSet={srcDesktop?.filename}
        className={className}
        media={`(min-width: ${TABLET_WIDTH}px)`}
      />
      <Image
        src={srcMobile?.filename}
        className={className}
        alt={srcMobile?.alt}
      />
    </picture>
  );
};
